import React from 'react'
import { formatAdSlot } from './ViewSizeMappings'
import { getAdSize } from 'common/advertising/get-ad-size'
import { css } from '@emotion/css'
import { calcRem } from 'component-library/__styling/style-functions'
import { AdState } from 'common/advertising/ad-state'
import { sizeProps } from 'common/advertising/size-props'
import { AdDefinition } from 'common/advertising/add-ads'

export const DebugAdUnitRow: React.FC<{
    adState: AdState
    ad: AdDefinition
    forBreakpoint: number
}> = ({ adState, ad, forBreakpoint }) => {
    const dataItem = css({
        border: '1px solid #e6e6e6',
        padding: calcRem(5),
    })

    const rowItem = css({
        backgroundAttachment: 'fixed',
    })

    const unit = adState.unitLookup(ad.id, forBreakpoint)
    if (!unit) {
        // Unit not for this breakpoint
        return null
    }

    const sizeMapping = getAdSize(unit.sizeMapping, forBreakpoint)
    if (!sizeMapping) {
        return null
    }
    const sizeProp = sizeProps[ad.size]

    return (
        <tr className={rowItem}>
            <td className={dataItem}>{ad.size}</td>
            <td className={dataItem}>{unit.targeting && unit.targeting.pos}</td>
            <td className={dataItem}>{unit.id}</td>
            <td className={dataItem}>{formatAdSlot(sizeMapping.slot)}</td>
            <td className={dataItem}>{sizeProp.adPosCategory}</td>
            <td className={dataItem}>{unit.exclusionLabels}</td>
        </tr>
    )
}
